import React from 'react';

/**
 * Componente para visualização gráfica das posições de pneus de um template
 * Renderiza um diagrama visual baseado no número e posições dos pneus
 */
const TirePositionVisualizer = ({ template, compact = false }) => {
  if (!template || !template.positions) return null;

  const totalTires = template.total_tires;
  const positions = template.positions;

  // Renderizar diagrama baseado no número de pneus
  const renderDiagram = () => {
    // Carro/Van (4 pneus)
    if (totalTires === 4) {
      return (
        <div className="flex flex-col items-center gap-3">
          <div className="flex justify-between w-full max-w-xs">
            {/* Dianteiros */}
            <TireCircle position={positions.find(p => p.position === 'front_left')} size={compact ? 'sm' : 'md'} />
            <TireCircle position={positions.find(p => p.position === 'front_right')} size={compact ? 'sm' : 'md'} />
          </div>
          <div className="w-1 h-8 bg-gray-300 dark:bg-gray-600"></div>
          <div className="flex justify-between w-full max-w-xs">
            {/* Traseiros */}
            <TireCircle position={positions.find(p => p.position === 'rear_left')} size={compact ? 'sm' : 'md'} />
            <TireCircle position={positions.find(p => p.position === 'rear_right')} size={compact ? 'sm' : 'md'} />
          </div>
        </div>
      );
    }

    // Motocicleta (2 pneus)
    if (totalTires === 2) {
      return (
        <div className="flex items-center gap-4 justify-center">
          <TireCircle position={positions.find(p => p.position === 'front')} size={compact ? 'sm' : 'md'} />
          <div className="w-12 h-1 bg-gray-300 dark:bg-gray-600"></div>
          <TireCircle position={positions.find(p => p.position === 'rear')} size={compact ? 'sm' : 'md'} />
        </div>
      );
    }

    // Caminhão 6x2 (10 pneus)
    if (totalTires === 10) {
      return (
        <div className="flex flex-col items-center gap-2">
          {/* Dianteiros */}
          <div className="flex justify-between w-full max-w-sm">
            <TireCircle position={positions.find(p => p.position === 'front_left')} size={compact ? 'xs' : 'sm'} />
            <TireCircle position={positions.find(p => p.position === 'front_right')} size={compact ? 'xs' : 'sm'} />
          </div>
          <div className="w-1 h-4 bg-gray-300 dark:bg-gray-600"></div>
          {/* Intermediários (duplos) */}
          <div className="flex justify-between w-full max-w-md">
            <div className="flex gap-1">
              <TireCircle position={positions.find(p => p.position === 'middle_inner_left')} size={compact ? 'xs' : 'sm'} />
              <TireCircle position={positions.find(p => p.position === 'middle_outer_left')} size={compact ? 'xs' : 'sm'} />
            </div>
            <div className="flex gap-1">
              <TireCircle position={positions.find(p => p.position === 'middle_inner_right')} size={compact ? 'xs' : 'sm'} />
              <TireCircle position={positions.find(p => p.position === 'middle_outer_right')} size={compact ? 'xs' : 'sm'} />
            </div>
          </div>
          <div className="w-1 h-4 bg-gray-300 dark:bg-gray-600"></div>
          {/* Traseiros (duplos) */}
          <div className="flex justify-between w-full max-w-md">
            <div className="flex gap-1">
              <TireCircle position={positions.find(p => p.position === 'rear_inner_left')} size={compact ? 'xs' : 'sm'} />
              <TireCircle position={positions.find(p => p.position === 'rear_outer_left')} size={compact ? 'xs' : 'sm'} />
            </div>
            <div className="flex gap-1">
              <TireCircle position={positions.find(p => p.position === 'rear_inner_right')} size={compact ? 'xs' : 'sm'} />
              <TireCircle position={positions.find(p => p.position === 'rear_outer_right')} size={compact ? 'xs' : 'sm'} />
            </div>
          </div>
        </div>
      );
    }

    // Caminhão 6x4 (14 pneus)
    if (totalTires === 14) {
      return (
        <div className="flex flex-col items-center gap-2">
          {/* Dianteiros */}
          <div className="flex justify-between w-full max-w-sm">
            <TireCircle position={positions.find(p => p.position === 'front_left')} size={compact ? 'xs' : 'sm'} />
            <TireCircle position={positions.find(p => p.position === 'front_right')} size={compact ? 'xs' : 'sm'} />
          </div>
          <div className="w-1 h-3 bg-gray-300 dark:bg-gray-600"></div>
          {/* Intermediários 1 (duplos) */}
          <div className="flex justify-between w-full max-w-md">
            <div className="flex gap-1">
              <TireCircle position={positions.find(p => p.position === 'middle1_inner_left')} size={compact ? 'xs' : 'sm'} />
              <TireCircle position={positions.find(p => p.position === 'middle1_outer_left')} size={compact ? 'xs' : 'sm'} />
            </div>
            <div className="flex gap-1">
              <TireCircle position={positions.find(p => p.position === 'middle1_inner_right')} size={compact ? 'xs' : 'sm'} />
              <TireCircle position={positions.find(p => p.position === 'middle1_outer_right')} size={compact ? 'xs' : 'sm'} />
            </div>
          </div>
          <div className="w-1 h-3 bg-gray-300 dark:bg-gray-600"></div>
          {/* Intermediários 2 (duplos) */}
          <div className="flex justify-between w-full max-w-md">
            <div className="flex gap-1">
              <TireCircle position={positions.find(p => p.position === 'middle2_inner_left')} size={compact ? 'xs' : 'sm'} />
              <TireCircle position={positions.find(p => p.position === 'middle2_outer_left')} size={compact ? 'xs' : 'sm'} />
            </div>
            <div className="flex gap-1">
              <TireCircle position={positions.find(p => p.position === 'middle2_inner_right')} size={compact ? 'xs' : 'sm'} />
              <TireCircle position={positions.find(p => p.position === 'middle2_outer_right')} size={compact ? 'xs' : 'sm'} />
            </div>
          </div>
          <div className="w-1 h-3 bg-gray-300 dark:bg-gray-600"></div>
          {/* Traseiros (duplos) */}
          <div className="flex justify-between w-full max-w-md">
            <div className="flex gap-1">
              <TireCircle position={positions.find(p => p.position === 'rear_inner_left')} size={compact ? 'xs' : 'sm'} />
              <TireCircle position={positions.find(p => p.position === 'rear_outer_left')} size={compact ? 'xs' : 'sm'} />
            </div>
            <div className="flex gap-1">
              <TireCircle position={positions.find(p => p.position === 'rear_inner_right')} size={compact ? 'xs' : 'sm'} />
              <TireCircle position={positions.find(p => p.position === 'rear_outer_right')} size={compact ? 'xs' : 'sm'} />
            </div>
          </div>
        </div>
      );
    }

    // Configuração genérica para outros casos
    return (
      <div className="grid grid-cols-2 gap-3 max-w-sm mx-auto">
        {positions.map((pos, idx) => (
          <TireCircle key={idx} position={pos} size={compact ? 'xs' : 'sm'} />
        ))}
      </div>
    );
  };

  return (
    <div className="p-4 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700">
      {renderDiagram()}
    </div>
  );
};

// Componente de círculo representando um pneu
const TireCircle = ({ position, size = 'md' }) => {
  if (!position) return null;

  const sizeClasses = {
    xs: 'w-8 h-8 text-xs',
    sm: 'w-10 h-10 text-xs',
    md: 'w-12 h-12 text-sm'
  };

  return (
    <div className="flex flex-col items-center gap-1">
      <div
        className={`${sizeClasses[size]} rounded-full bg-blue-500 dark:bg-blue-600 flex items-center justify-center text-white font-bold shadow-lg border-2 border-blue-700 dark:border-blue-800`}
        title={position.label}
      >
        <svg className="w-3/4 h-3/4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="10" strokeWidth="2" />
          <circle cx="12" cy="12" r="6" strokeWidth="1.5" />
          <circle cx="12" cy="12" r="2" fill="currentColor" />
        </svg>
      </div>
      {size !== 'xs' && (
        <span className="text-xs text-gray-600 dark:text-gray-400 text-center max-w-[80px] line-clamp-2">
          {position.label}
        </span>
      )}
    </div>
  );
};

export default TirePositionVisualizer;
